module.exports = __webpack_public_path__ + "img/candle1.6666d634.gif";